export default __webpack_public_path__ + "static/media/kitchen4-afterD-1440w.be96be74.avif";